import React, { useState } from "react";
import axios from "axios";
import Logo  from '../../public/assets/images/logo1.png';
import { Link, useNavigate } from 'react-router-dom';







function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
  
     <button onClick={handleLogout} className="relative overflow-hidden py-3 px-8 mt-4 mb-2 text-white font-semibold bg-slate-900 shadow-xl text-lg group">
          <span className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-600 group-hover:from-red-600 group-hover:to-red-600 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Log out</span>
        </button>
  );
}


















export default function AddProperty() {
   const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    price: "",
    status: "unsold",
    bathrooms: "",
    bedrooms: "",
    area: "",
    garages: "",
    yearBuilt: "",
  });
  const [mainImage, setMainImage] = useState(null);
  const [images, setImages] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    setMainImage(file);
  };

  const handleImagesChange = (e) => {
    setImages([...e.target.files]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("mainImage", mainImage);
    images.forEach((img) => {
      form.append("images", img);
    });
    const numberFields = ["price", "bathrooms", "bedrooms", "area", "garages", "yearBuilt"];

Object.entries(formData).forEach(([key, value]) => {
  const parsedValue = numberFields.includes(key) ? Number(value) : value;
  form.append(key, parsedValue);
});

    try {
      const response = await axios.post("https://investorrise-gxm0.onrender.com/api/properties", form, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
      alert("Property added successfully");
     navigate('/recent-properties');
    } catch (error) {
      console.error(error);
      alert("Error adding property");
    }


  };

  return (
  <div className="pt-20 pb-20 bg-gray-800">
  <LogoutButton />
   <Link to="/delete-property">
                <button className="relative overflow-hidden py-3 px-8 mt-4 mb-2 text-white font-semibold bg-slate-900 shadow-xl text-lg group ml-4">
          <span className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-600 group-hover:from-red-600 group-hover:to-red-600 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Delete Property</span>
        </button>
        </Link>
 <div className="max-w-2xl mx-auto p-4 shadow-lg shadow-teal-500 rounded-lg mt-1 bg-slate-900 text-white text-base scale-90">
  <div className="flex items-center mb-4">
    <img
      src={Logo}
      alt="Property Icon"
      className="w-14 h-14 mr-3 rounded-full"
    />
    <h1 className="text-2xl font-bold">Add Property</h1>
  </div>
  <form onSubmit={handleSubmit} className="space-y-6">
    {/* Main Image Upload */}
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div className="sm:w-2/3 w-full">
        <label className="block font-semibold mb-1">Main Image</label>
        <input type="file" accept="image/*" onChange={handleMainImageChange} required className="w-full bg-white text-black p-1.5 rounded text-base" />
      </div>
      {mainImage && (
        <img
          src={URL.createObjectURL(mainImage)}
          alt="Main Preview"
          className="w-20 h-16 object-cover rounded border"
        />
      )}
    </div>

    {/* Other Images Upload */}
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div className="sm:w-2/3 w-full">
        <label className="block font-semibold mb-1">Other Images</label>
        <input type="file" accept="image/*" multiple onChange={handleImagesChange} className="w-full bg-white text-black p-1.5 rounded text-base" />
      </div>
      <div className="flex gap-1 flex-wrap">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={URL.createObjectURL(img)}
            alt={`Preview ${idx}`}
            className="w-14 h-12 object-cover rounded border"
          />
        ))}
      </div>
    </div>

    {/* 2-Column Fields */}
   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
  {["title", "price", "status", "bathrooms", "bedrooms", "area", "garages", "yearBuilt"].map((field, index) => (
    <div key={index}>
      <label className="block font-semibold mb-1 capitalize">
        {field.replace(/([A-Z])/g, ' $1')}
      </label>

      {field === "status" ? (
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="w-full text-slate-900 p-2 rounded border text-base"
        >
          <option value="unsold">Unsold</option>
          <option value="sold">Sold</option>
        </select>
      ) : (
        <input
          type={["price", "bathrooms", "bedrooms", "area", "garages", "yearBuilt"].includes(field) ? "number" : "text"}
          name={field}
          value={formData[field]}
          onChange={handleChange}
          className="w-full text-slate-900 p-2 rounded border text-base"
          required
        />
      )}
    </div>
  ))}
</div>


    {/* Submit Button */}
    <div className="text-center">
      {/* <button type="submit" className="bg-teal-500 hover:bg-slate-700 text-white font-semibold py-2 px-4  transition text-base">
        Submit
      </button> */}
      <button type="submit" className="relative overflow-hidden py-2 px-4 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-base group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Submit</span>
    </button>
    </div>
  </form>
</div>

{/* <br/><br/> */}

    </div>
  );
}
